import { call, put, takeLatest } from "redux-saga/effects"

import {
    GET_ADMIN_FILTER_PACKAGES,
    UPDATE_ADMIN_FILTER_PACKAGES,
    DELETE_ADMIN_FILTER_PACKAGES,
    POST_ADMIN_FILTER_PACKAGES
} from "./actionTypes"

import {
    getAdminFilterPackagesError,
    getAdminFilterPackagesSuccess,
    createAdminFilterPackagesSuccess,
    createAdminFilterPackagesError,
    updateAdminFilterPackagesSuccess,
    updateAdminFilterPackagesError,
    deleteAdminFilterPackagesSuccess,
    deleteAdminFilterPackagesError,
} from "./actions"

import {
    genericGetRequest, genericPostRequest, genericPutRequest, genericDeleteRequest
} from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetAdminFilterPackages() {
    try {
        let user = bsh_getAdminUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_filter_packages`;
        const request_body = {
            body: {},
            headers: {
                Authorization: user.token,
            }
        }
        const response = yield call(genericGetRequest, URL, request_body.body, request_body.headers)
        yield put(getAdminFilterPackagesSuccess(response))
    } catch (error) {
        yield put(getAdminFilterPackagesError(error))
    }
}

function* onCreateAdminFilterPackages(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_filter_packages`;
        const request_body = {
            body: JSON.stringify({
                ...action.payload
            }),
            headers: {
                "Authorization": user.token,
                "Content-Type": "application/json"
            }
        }
        const response = yield call(genericPostRequest, URL, request_body)
        yield put(createAdminFilterPackagesSuccess(response))
    } catch (error) {
        yield put(createAdminFilterPackagesError(error))
    }
}

function* onUpdateAdminFilterPackages(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_filter_packages/${action?.payload?.filter_package?.id}`;
        const request_body = {
            body: JSON.stringify({
                ...action.payload
            }),
            headers: {
                "Authorization": user.token,
                "Content-Type": "application/json"
            }
        }
        const response = yield call(genericPutRequest, URL, request_body)
        yield put(updateAdminFilterPackagesSuccess(response))
    } catch (error) {
        yield put(updateAdminFilterPackagesError(error))
    }
}

function* onDeleteAdminFilterPackages(action) {
    try {
        let user = bsh_getAdminUserDetails();

        const response = yield call(
            genericDeleteRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/admin_filter_packages/${action.payload}`,
            {
                headers: {
                    Authorization: user.token,
                    'Content-Type': 'application/json'
                }
            }
        )
        yield put(deleteAdminFilterPackagesSuccess(response))
    } catch (error) {
        yield put(deleteAdminFilterPackagesError(error))
    }
}

function* AdminFilterPackagesSaga() {
    yield takeLatest(GET_ADMIN_FILTER_PACKAGES, onGetAdminFilterPackages)
    yield takeLatest(POST_ADMIN_FILTER_PACKAGES, onCreateAdminFilterPackages)
    yield takeLatest(UPDATE_ADMIN_FILTER_PACKAGES, onUpdateAdminFilterPackages)
    yield takeLatest(DELETE_ADMIN_FILTER_PACKAGES, onDeleteAdminFilterPackages)
}

export default AdminFilterPackagesSaga;

